import React, {useMemo, useRef, useState} from 'react'
import utils from 'helpers/utils';
import Component from 'components/organisms/Utils/Component/Component';

export const DialogControlContext = React.createContext(null)

export function useDialogControl () {
  return React.useContext(DialogControlContext);
}

const DialogProvider = (props) => {
  const {
    children
  } = props;

  const dialogKeyRef = useRef(null);
  const [internalState, setInternalState] = useState({
    DialogComponent: null,
    onClose: null,
    open: false,
    clickAway: true
  });

  const handleClose = (e, reason) => {
    if (internalState.onClose) {
      internalState.onClose(e, reason);
    } else {
      if (internalState.clickAway || reason !== 'backdropClick') {
        setInternalState(utils.updater({
          DialogComponent: null,
          open: false,
          onClose: null,
          clickAway: true
        }, true));
      }
    }
  }

  // context
  const context = useMemo(() => ({
    show: (DialogComponent, clickAway = true, onClose = null, open = true) => {
      dialogKeyRef.current += 1;

      setInternalState(utils.updater({
        key: dialogKeyRef.current,
        DialogComponent: DialogComponent,
        open: open,
        onClose: onClose,
        clickAway: clickAway
      }, true));

      return dialogKeyRef.current;
    },
    hide: () => {
      setInternalState(utils.updater({
        key: null,
        DialogComponent: null,
        open: false,
        onClose: null,
        clickAway: true
      }, true))
    }
  }), []);

  return <React.Fragment>
    <DialogControlContext.Provider value={context}>
      {children}
    </DialogControlContext.Provider>
    {internalState.DialogComponent ? <DialogProvider>
      <Component key={internalState.key}
                 Original={internalState.DialogComponent}
                 open={internalState.open}
                 onClose={handleClose} />
    </DialogProvider> : null}
  </React.Fragment>
};

DialogProvider.propTypes = {
}

export default DialogProvider;
